export enum ModalNames {
  discardCards = "discardCards",
  choice = "choice",
  intrigue = "intrigue",
  combat = "combat",
  shop = "shop",
  endGame = "endGame",
  help = "help",
  playerLeader = "playerLeader",
  lookDeck = "lookDeck",
  history = "history",
  tech = "tech",
  authorizeUndo = "authorizeUndo",
}
